<div class="content__wrapper">
  <p-toast position="bottom-right" key="main" />
  @if (showSidebar) {
    <app-nav-menu
      [env]="environment"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      [userToken]="userToken"
      appTitle="Sierra Asset"
      (logout)="onLogout()"
      [menuItems]="menuItems"
      [sites]="sites"
      [selectedSiteId]="selectedSiteId"
      (siteChanged)="onSiteChanged($event)"
    />
  }

  <div class="cs-shell">
    @if (showSidebar) {
      <csl-main-header />
    }
    <router-outlet></router-outlet>
  </div>
  <!--   This Select is only for testing -->
  <div class="language-switcher">
    <!-- <p-select
      [options]="languageOptions"
      [(ngModel)]="selectedLanguage"
      [showClear]="false"
      placeholder="Select Language"
      class="w-full md:w-56"
      (onChange)="switchLanguage(selectedLanguage)"
    >
    </p-select> -->
  </div>
</div>
<csl-environment-indicator [envType]="environment" />
